import { Directive, ElementRef, Inject, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { VIRTUAL_SCROLL_STRATEGY } from '@angular/cdk/scrolling';

/** The one method this directive needs from whatever strategy is provided under VIRTUAL_SCROLL_STRATEGY. */
export interface MeasuredHeightReporter {
  updateItemHeight(key: string, height: number): void;
}

@Directive({
  selector: '[virtualItemMeasure]',
  standalone: true
})
export class VirtualItemMeasureDirective implements OnInit, OnDestroy {
  @Input({ required: true }) virtualItemMeasureKey: string;

  private observer: ResizeObserver;

  constructor(
    private readonly el: ElementRef<HTMLElement>,
    private readonly ngZone: NgZone,
    @Inject(VIRTUAL_SCROLL_STRATEGY) private readonly strategy: MeasuredHeightReporter
  ) {}

  ngOnInit(): void {
    // ResizeObserver is zone-patched, so creating and running it outside the zone keeps a
    // measurement report from triggering change detection on its own; the strategy schedules
    // that separately once it actually needs a new range.
    this.ngZone.runOutsideAngular(() => {
      this.observer = new ResizeObserver(entries => {
        const entry = entries[0];
        const height = entry?.borderBoxSize?.[0]?.blockSize ?? entry?.contentRect.height;
        if (height > 0) {
          this.strategy.updateItemHeight(this.virtualItemMeasureKey, height);
        }
      });
      this.observer.observe(this.el.nativeElement);
    });
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }
}
